<template>
    <div>
        <section v-if="isRegistered" class="block-page" style="padding-top: 70px;">
            <div class="container">
                <article class="text-centered thank-you">
                    <header class="section-header--mb-big">
                        <figure>
                            <span class="material-symbols-rounded full-circle icon-check-success">check</span>
                        </figure>
                        <span class="headline-lg">Vielen Dank für Ihr Interesse am Vitadio-Programm, aber es scheint, als hätten Sie bereits mit unserem Registrierungsprozess begonnen.</span>
                    </header>

                    <section>
                        <v-button href="/" position="center" size="lg" label="Ende"></v-button>
                        <p class="text-default text-color-default">Sollten Sie Fragen haben oder Hilfe benötigen, kontaktieren Sie uns gerne unter <a href="tel:0157 382 899 53">0157 382 899 53</a> (Mo-Fr von 9-17 Uhr) oder per E-Mail an <a href="mailto:kontakt@vitadio.de">kontakt@vitadio.de</a>.</p>
                    </section>
                </article>
            </div>
        </section>
        
        <section v-else class="onboarding-de onboarding-type-a">
            <div class="container">                
                <form id="onboarding-de" class="wrapper wrapper-tab-5" role="form" method="post" @submit.prevent="submit" novalidate autocomplete="off">
                    <div class="form-wrapper">
                        <ol class="no-list-style">
                            <li class="active">
                                <span class="headline-sm text-bold">Buchen Sie ein Gespräch mit unserem Team</span>

                                <form-input-type-text name="name" label="Name" full-border required></form-input-type-text>

                                <form-input-type-phone-number
                                    name="phone"
                                    label="Ihre Handynummer"
                                    :errors="errors.phone"
                                    phoneCountry="de"
                                    required
                                    full-border
                                ></form-input-type-phone-number>

                                <form-input-type-datepicker
                                    v-if="token && !loading"
                                    label="Datum auswählen"
                                    name="datepicker-call"
                                    @date="setDate"
                                    :start-date="startDate"
                                    :value="firstAvailableDate"
                                    :end-date="endDate"
                                    :disabled-dates="disabledDays"
                                    language="de"
                                    full-border
                                    required
                                ></form-input-type-datepicker>

                                <form-input-type-select
                                    v-if="token && !loading"
                                    name="time"
                                    :label="(availableSlots[date]?.length === 0) ? 'kein freier Termin' : 'Uhrzeit auswählen'"
                                    :options="availableSlots[date] || []"
                                    :value="availableSlots[date]?.[0]?.value || null"
                                    required
                                    full-border
                                ></form-input-type-select>

                                <form-input-error
                                    v-if="errors && errors.datetime"
                                    :error="__(errors.datetime[0])"
                                ></form-input-error>

                                <v-button label="Senden" size="lg" type="submit" full-width></v-button>
                            </li>

                            <li><p>Erhalten Sie während des Gesprächs alle Informationen zum Verschreibungsprozess</p></li>
                            <li><p>Legen Sie mit der Vitadio-App los.</p></li>
                        </ol>

                        <figure>
                            <img src="imgs/web/img_quiz_form.svg" alt="" />
                        </figure>
                    </div>
                </form>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    data() {
        return {
            errors: {},
            token: null,
            availableSlots: [],
            client: null,
            date: null,
            loading: true,
            endDate: moment().add(21, 'days').toDate(),
            availableDays: [],
            allDays: [],
            disabledDays: [],
            firstAvailableDate: null
        }
    },
    watch: {
        questionNumber() {
            var previous = $('#quiz-button-previous')

            if (
                this.questionNumber === 1 || 
                this.questionNumber === 2 || 
                this.questionNumber === 3 
                ) {
                previous.show()
            } else {
                previous.hide()
            }
        }
    },

    mounted() {
        this.login()
    },

    computed: {
        isRegistered() {
            if(this.errors && this.errors.phone && this.errors.phone[0] === 'Die Telefonnummer ist bereits vergeben.') {
                return true
            } else {
                return false
            }
        },
        startDate() {
            var startDate = moment().add(1, 'days').toDate()

            if(moment(startDate).day() === 6 ||moment(startDate).day() === 7) {
                startDate = moment().weekday(7).toDate()
            }

            return startDate
        }
    },

    methods: {
        submit() {
            let form = {
                datetime: this.date+" "+$('#time').val(),
                phone_country: $('#phone_country').val(),
                phone: $('#phone').val(),
                name: $('#name').val(),
                email: 'no-email@vitad.io'
            }

            if(form.name === "") {
                form.name = "Anonym"
            }

            axios
                .post('api/web_consultation_form/', form, {
                    headers: {
                        'Accept-Language': 'de'
                    }
                })
                .then((e) => {
                    window.dataLayer.push({
                        event: 'pre_registration_web',
                        conversion: 'Phone number received'
                    })

                    setTimeout(() => {
                        window.location.replace('/onboarding-quiz-success')
                    }, 250);
                })
                .catch((e) => {
                    this.errors = e.response.data.errors
                    console.log(e.response)
                    Vuemit.fire('Button--sending-failed', true) 
                })
        },
        async login() {
            var loginClient = new JSONRpcClient({
                url: 'https://user-api.simplybook.me/login',
                onerror: function (error) {
                    alert(error)
                }
            })

            this.token = loginClient.getToken(
                'vitad',
                '5c0f43408a980dc924c31fc98fce0122c3b785f5256b495f1ddd4e809ac6de53'
            )

            this.client = new JSONRpcClient({
                url: 'https://user-api.simplybook.me',
                headers: {
                    'X-Company-Login': 'vitad',
                    'X-Token': this.token
                },
                onerror: function (error) {
                    alert(error)
                }
            })

            await this.getAllDays()
            this.initializeForm()
        },
        async getAllDays() {
            this.allDays = this.client.getAvailableTimeIntervals(this.startDate, this.endDate, 1, 1)

            this.getAvailableDays()

            for (const date of this.availableDays) {
                await this.getDaktelaCalls(date)
            }

            this.getDisabledDays()
        },
        async getAvailableSlots(date, daktelaCalls) {
            let slots = []
            slots = this.client.getStartTimeMatrix(date, date, 1, 1)[date]

            if(date === moment().add(1, 'days').format("YYYY-MM-DD")) {
                var now = moment().format("HH:mm:ss")

                slots = slots.filter((time) => time > now)
            }

            daktelaCalls = daktelaCalls.filter((call) => call.title.includes("Consultation request"))

            daktelaCalls.forEach(slot => {
                var slotTime = moment(slot.reopen).format("HH:mm:ss")

                if((moment(slot.reopen).get('minute')) < 30 && moment(slot.reopen).get('minute') > 0) {
                    if((moment(slot.reopen).get('minute')) < 30 && moment(slot.reopen).get('minute') > 15) {
                        slotTime = moment(slot.reopen).format("HH:30:ss")

                        slots = slots.filter((time) => time !== slotTime)
                    }
                    
                    slotTime = moment(slot.reopen).format("HH:00:ss")
                }

                if((moment(slot.reopen).get('minute')) < 60 && moment(slot.reopen).get('minute') > 30) {
                    if((moment(slot.reopen).get('minute')) < 60 && moment(slot.reopen).get('minute') > 45) {
                        slotTime = moment(slot.reopen).add(1, 'hour').format("HH:00:ss")

                        slots = slots.filter((time) => time !== slotTime)
                    }
                    
                    slotTime = moment(slot.reopen).format("HH:30:ss")
                }

                slots = slots.filter((time) => time !== slotTime)
            })

            if(slots.length === 0 ) {
                this.disabledDays.push(date)
            } else {
                if(this.firstAvailableDate === null) {
                    this.firstAvailableDate = moment(date).toDate()
                }

                slots.forEach(slot => {
                    if (!this.availableSlots[date]) {
                        this.availableSlots[date] = [];
                    }
                    this.availableSlots[date].push({'label': slot.substr(0, 5), 'value': slot})  
                });
            }

            this.$nextTick(() => {
                $('#time').selectpicker('refresh');
                $('#time').selectpicker('render');
            });
        },
        async getDaktelaCalls(date) {
            var that = this

            const token = "3b8cbc9b2b1839558425fca34e7ce0612104ace3"
            const instance = axios.create()

            delete instance.defaults.headers.common['X-CSRF-TOKEN']
            delete instance.defaults.headers.common['X-Requested-With']

            await instance.get('https://vitadio.daktela.com/api/v6/tickets.json?accessToken='+token+'&filter[logic]=and&filter[filters][0][field]=category.name&filter[filters][0][operator]=eq&filter[filters][0][value]=categories_63287e65252a1965378762&filter[filters][1][field]=reopen&filter[filters][1][operator]=isnotnull&filter[filters][2][field]=stage&filter[filters][2][operator]=neq&filter[filters][2][value]=CLOSE&fields[0]=reopen&fields[1]=title&fields[2]=name&fields[3]=stage&fields[4]=last_activity&fields[5]=last_activity_client&fields[6]=last_activity_operator=and&filter[filters][3][field]=reopen&filter[filters][3][operator]=gte&filter[filters][3][value]='+date+'+00:00:00&filter[filters][4][field]=reopen&filter[filters][4][operator]=lte&filter[filters][4][value]='+date+'+23:59:59')
            .then(function (e) {
                that.getAvailableSlots(date, e.data.result.data)
            })    
            .catch(function (error) {
                console.log(error)
            })
        },
        setDate(date) {
            this.date = moment(date).format('YYYY-MM-DD')

            this.$nextTick(() => {
                $('#time').selectpicker('refresh');
                $('#time').selectpicker('render');
            });
        },
        getAvailableDays() {
            const allDays = this.allDays

            for (const [date, details] of Object.entries(allDays)) {
                if (details["1"].length !== 0) {
                    this.availableDays.push(date)
                }
            }
        },
        getDisabledDays() {
            const allDays = this.allDays

            for (const [date, details] of Object.entries(allDays)) {
                if (details["1"].length === 0) {
                    this.disabledDays.push(date)
                }
            }
        },
        initializeForm() {
            this.loading = false
        }
    }
}
</script>
